import {createContext, useState} from "react";

export const UserTransactionContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptyUserTransaction = {
    }

    const [userTransaction, setUserTransaction] = useState(emptyUserTransaction);
    const [userTransactions, setUserTransactions] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [userTransactionDialog, setUserTransactionDialog] = useState(false);

    const resetUserTransaction = () => {
        setUserTransaction(emptyUserTransaction);
    };

    // Make the context object:
    const userTransactionContext = {
        userTransaction,
        resetUserTransaction,
        setUserTransaction,
        userTransactions,
        setUserTransactions,
        submitted,
        setSubmitted,
        userTransactionDialog,
        setUserTransactionDialog,
    };

    // pass the value in provider and return
    return <UserTransactionContext.Provider value={userTransactionContext}>{children}</UserTransactionContext.Provider>;
}

export const {Consumer} = UserTransactionContext;
